// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"IntakeLossButtons_buttonsWrapper__yi-ZO"};